'use client'

import dynamic from 'next/dynamic'

const DistinctiveFactorsChartPie = dynamic(() => import('./DistinctiveFactorsChartPie'), { ssr: false })

export default DistinctiveFactorsChartPie
